import { createWorker, ReminderWorkerMessageTypes } from './Reminders.worker';
import { ReminderWorkerMessageItem } from './reminder.model-shared';
import { Log } from '@lightningjs/sdk';

type callback = (data: ReminderWorkerMessageItem[]) => void;

export default class ReminderManager {
  private _worker?: Worker;
  private subscribers: callback[] = [];

  start() {
    const code = `(${createWorker.toString()})()`;
    const blob = new Blob([code.replace('"use strict";', '')]);
    const blobURL = (URL || webkitURL).createObjectURL(blob, {
      type: 'application/javascript; charset=utf-8',
    });
    this._worker = new Worker(blobURL);
    this._worker.onmessage = this.handleMessage.bind(this);
    // this._worker.postMessage({ type: 'PING', message: 'hoi' });
  }

  stop() {
    // todo send message to worker to call stop() on itsself and also undo all timers
  }

  addReminder(reminder: ReminderWorkerMessageItem) {
    this._worker?.postMessage({ type: ReminderWorkerMessageTypes.ADD, items: [reminder] });
  }

  renewReminders(reminders: ReminderWorkerMessageItem[]) {
    this._worker?.postMessage({ type: ReminderWorkerMessageTypes.RENEW, items: reminders });
  }

  clear() {
    this._worker?.postMessage({ type: ReminderWorkerMessageTypes.CLEAR });
  }

  close() {
    this._worker?.postMessage({ type: ReminderWorkerMessageTypes.CLOSE });
  }

  subscribe(cb: callback) {
    this.subscribers.push(cb);
  }

  unsubscribe(cb: callback) {
    this.subscribers = this.subscribers.filter(f => f !== cb);
  }

  private handleMessage({ data }: { data: { type: string; items: ReminderWorkerMessageItem[] } }) {
    Log.info('[ReminderWorkerManager]', 'received message', data);
    if (data.type === ReminderWorkerMessageTypes.NOTIFY) this.subscribers.forEach(f => f(data.items ?? []));
  }
}
